<template>
  <div id="app">
    <Updater />
    <v-header />
    <section-main />
    <section-slogan />
    <section-positions />

    <!-- <section-subscribe />  -->

    <section-audit />

    <section-advantages />
    <section-clients />
    <section-how-it-works />

    <section-about-slogan />
    <!-- CAN MERGE -->

    <section-logos />
    <section-partners />
    <section-price />
    <section-registration />
    <BitrixCallbackButton />
    <v-footer />
  </div>
</template>

<script>
import Updater from './Updater'
import VHeader from '@/components/layouts/VHeader.vue'
import SectionMain from '@/components/layouts/SectionMain'
import SectionSlogan from '@/components/layouts/SectionSlogan'
import SectionPositions from '@/components/layouts/SectionPositions'
// import SectionSubscribe from "@/components/layouts/SectionSubscribe";
import SectionAdvantages from '@/components/layouts/SectionAdvantages'
// import SectionRegistration from '@/components/layouts/SectionRegistration'
import SectionPrice from '@/components/layouts/SectionPrice'
import SectionLogos from '@/components/layouts/SectionLogos'
import SectionAboutSlogan from '@/components/layouts/SectionAboutSlogan'
import SectionClients from '@/components/layouts/SectionClients'
import SectionHowItWorks from '@/components/layouts/SectionHowItWorks'
import SectionPartners from '@/components/layouts/SectionPartners'
import BitrixCallbackButton from '@/components/bitrix/BitrixCallbackButton'
import SectionAudit from '@/components/layouts/SectionAudit'
import VFooter from '@/components/layouts/VFooter'

export default {
  components: {
    Updater,
    VHeader,
    SectionMain,
    SectionSlogan,
    SectionPositions,
    // SectionSubscribe,
    SectionAudit,
    SectionAdvantages,
    SectionRegistration: () =>
      import('@/components/layouts/SectionRegistration'),
    SectionPrice,
    SectionLogos,
    SectionAboutSlogan,
    SectionClients,
    SectionHowItWorks,
    SectionPartners,
    BitrixCallbackButton,
    VFooter,
  },
}
</script>

<style>
strong {
  font-weight: 600;
}

.text-t {
  font-size: 14px;
}
.text-sm {
  font-size: 16px;
}
.text-md {
  font-size: 18px;
}
.text-b {
  font-size: 20px;
}
.uppercase {
  text-transform: uppercase;
}
</style>

<style>
/* TABLET DEVICE */
@media (max-width: 670px) {
  .text-t {
    font-size: 12px;
  }
  .text-sm {
    font-size: 14px;
  }
  .text-md {
    font-size: 16px;
  }
  .text-b {
    font-size: 18px;
  }
}

@media (max-width: 375px) {
  .text-t {
    font-size: 10px;
  }
  .text-sm {
    font-size: 12px;
  }
  .text-md {
    font-size: 14px;
  }
  .text-b {
    font-size: 16px;
  }
}
</style>
